import React from 'react';
import { TopBar } from '../../components/layout/TopBar';
import { Header } from '../../components/layout/Header';
import { Navigation } from '../../components/layout/Navigation';
import { MobileStickyBar } from '../../components/layout/MobileStickyBar';
import { Footer } from '../../components/layout/Footer';
import { useScreenInit } from '../../useScreenInit';
import { usePageTitle } from '../../hooks/usePageTitle';
import { CheckCircle2, MapPin, Wrench, Map, AlertTriangle, Search, Mail, Signpost, HelpCircle, PhoneCall } from 'lucide-react';
export function Services() {
  usePageTitle('Services | MidAtlantic Mailboxes');
  useScreenInit();
  return <div className="min-h-screen flex flex-col bg-brand-background" data-id="element-1767" data-mp="2hdsn9hq20yog">
      <TopBar data-id="element-1768" data-mp="2he123f5qme2a" />
      <Header data-id="element-1769" data-mp="2hboikxkbzvn4" />
      <Navigation data-id="element-1770" data-mp="22gickal8jwts" />

      <main className="flex-grow" data-id="element-1771" data-mp="22g0ct3zd70h4">
        {/* Hero Section */}
        <section className="bg-white border-b border-brand-border py-16 lg:py-24" data-id="element-1772" data-mp="22iuvor2qcd8f">
          <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-1773" data-mp="27ets91y7p1jx">
            <span className="inline-block py-1 px-3 rounded-full bg-brand-goldSoft text-brand-charcoal text-xs font-bold tracking-wide mb-4 uppercase border border-brand-gold/30" data-id="element-1774" data-mp="p29cyksy655j">
              Professional Installation & Diagnostics
            </span>
            <h1 className="text-4xl lg:text-5xl xl:text-6xl font-serif font-bold text-brand-charcoal mb-6 leading-tight" data-id="element-1775" data-mp="y1nxl3mfnli4">
              Comprehensive Mailbox & Sign Services
            </h1>
            <p className="text-lg lg:text-xl text-brand-muted max-w-3xl mx-auto leading-relaxed" data-id="element-1776" data-mp="6agi0kubi9v6">
              Welcome to MidAtlantic Mailbox, Inc., your trusted source for all
              your curbside & streetside needs. Whether you're planning a new
              street sign development, need a community mailbox installed, or
              require expert opinions on identifying models, our experienced
              team ensures your installations are secure and backed by
              professional expertise.
            </p>
          </div>
        </section>

        {/* Residential Services */}
        <section className="py-16 lg:py-24 bg-brand-goldWash border-b border-brand-border" data-id="element-1777" data-mp="1hq5p7lhlbrvc">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1778" data-mp="1moqh8xmov58p">
            <div className="flex flex-col lg:flex-row gap-12" data-id="element-1779" data-mp="1riuqjnjffpcy">
              <div className="lg:w-1/2" data-id="element-1780" data-mp="1wgwg8rbcymxe">
                <div className="flex items-center gap-3 mb-6" data-id="element-1781" data-mp="1wfl4o5bo8avq">
                  <div className="w-12 h-12 rounded-full bg-white text-brand-maroon flex items-center justify-center shadow-sm" data-id="element-1782" data-mp="yte0gwja4kjw">
                    <Mail size={24} data-id="element-1783" data-mp="13ta7z5r6qu47" />
                  </div>
                  <h2 className="text-3xl font-serif font-bold text-brand-charcoal" data-id="element-1784" data-mp="18rlep7m6ooi7">
                    Residential Services
                  </h2>
                </div>
                <p className="text-brand-charcoal/80 mb-8 text-lg" data-id="element-1785" data-mp="1dobt7qicbc1i">
                  Your Mailbox, Our Mission! We install all types of mailboxes,
                  from standard curbside units to decorative post-mounted
                  designs, ensuring a perfect fit for your property.
                </p>

                <div className="bg-white p-6 rounded-xl border border-brand-border shadow-sm mb-8" data-id="element-1786" data-mp="dk18qnf0lcao">
                  <h3 className="font-bold text-brand-charcoal text-xl mb-4 flex items-center gap-2" data-id="element-1787" data-mp="8lhp4tnw8clh">
                    <Wrench size={20} className="text-brand-maroon" data-id="element-1788" data-mp="3uypxejvya7xo" />
                    Installation Services Include:
                  </h3>
                  <ul className="space-y-3 text-brand-muted" data-id="element-1789" data-mp="3q0odjwqpa4l5">
                    <li className="flex items-start gap-2" data-id="element-1790" data-mp="3ly1lpvu14jny">
                      <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-1791" data-mp="3lwqf7o978xt5" />
                      <span data-id="element-1792" data-mp="3c0nfsq5qfd9w">Full-Unit Assembly</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1793" data-mp="1f7buqo90l8qd">
                      <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-1794" data-mp="1f6slrx1cduoh" />
                      <span data-id="element-1795" data-mp="7w4cb93oaae6">
                        Direct Burial Post Installation in Concrete to USPS
                        Guidelines & Regulatory Height
                      </span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1796" data-mp="3u1hroiogryz9">
                      <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-1797" data-mp="2vq33nqc4uek" />
                      <span data-id="element-1798" data-mp="3kadbxgqysa3d">Number Application</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1799" data-mp="3p3zo77t7ubyn">
                      <CheckCircle2 size={18} className="text-brand-maroon shrink-0 mt-0.5" data-id="element-1800" data-mp="3bcbgdgq029nh" />
                      <span data-id="element-1801" data-mp="3g8s5oe8xqu25">Removal & Disposal of Old System</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="lg:w-1/2 space-y-6" data-id="element-1802" data-mp="36bne1ywbm6dy">
                <div className="bg-white p-6 rounded-xl border border-brand-border shadow-sm" data-id="element-1803" data-mp="36ejb7l0cgr1c">
                  <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-1804" data-mp="2msq7l6y0z6bh">
                    <Search size={20} className="text-brand-maroon" data-id="element-1805" data-mp="2iro6slogmm7e" />
                    FREE Diagnostic & Estimating
                  </h3>
                  <p className="text-brand-muted text-sm leading-relaxed" data-id="element-1806" data-mp="2rpqaxa3hpuyw">
                    Struggling to identify your exact mailbox manufacturer,
                    model, or replacement part? We’ll diagnose any damage,
                    identify your model/manufacturer, and determine necessary
                    replacement parts. We provide a quote including pricing and
                    lead time, and offer installation within our service area.
                  </p>
                </div>

                <div className="bg-white p-6 rounded-xl border border-brand-border shadow-sm" data-id="element-1807" data-mp="3petdu9fk0e08">
                  <h3 className="font-bold text-brand-charcoal text-lg mb-2 flex items-center gap-2" data-id="element-1808" data-mp="3kfq9ysbb8dtu">
                    <HelpCircle size={20} className="text-brand-maroon" data-id="element-1809" data-mp="3riwr7dqqgo0m" />
                    HOA & Discontinued Models
                  </h3>
                  <p className="text-brand-muted text-sm leading-relaxed mb-3" data-id="element-1810" data-mp="9hi295507dc">
                    <strong data-id="element-1811" data-mp="59cc2lk7ld2m">Strict HOA Requirements:</strong> With 20 years of
                    industry experience, we can identify your required model via
                    photos and system records to ensure it matches perfectly and
                    avoids penalties.
                  </p>
                  <p className="text-brand-muted text-sm leading-relaxed" data-id="element-1812" data-mp="j08r19l7pvr7">
                    <strong data-id="element-1813" data-mp="o26ekg0nbcpy">Discontinued Models:</strong> For developments 10+
                    years old, models may be discontinued. We provide similar
                    options and recommend notifying your HOA immediately to
                    determine how to proceed. Even if we don't sell your
                    required model, we'll help identify it and point you to the
                    right manufacturer!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Commercial Services */}
        <section className="py-16 lg:py-24 bg-white border-b border-brand-border" data-id="element-1814" data-mp="2dhqxoi75owtq">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1815" data-mp="28j7cwl4atr2y">
            <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1816" data-mp="28kigokxquyu2">
              <h2 className="text-3xl lg:text-4xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-1817" data-mp="367hdcvofs6ry">
                Commercial Mailbox Services
              </h2>
              <p className="text-lg text-brand-muted leading-relaxed" data-id="element-1818" data-mp="315s4nmoos571">
                Developments, Cluster Boxes, Vertical, and Horizontal
                Multi-Tenant Mailboxes. We offer FREE estimating and diagnostic
                services to provide insight into costs, lead times, and
                regulations.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-1819" data-mp="1ftgx87n0qh4q">
              <div className="bg-brand-background p-8 rounded-xl border border-brand-border" data-id="element-1820" data-mp="25i4dadyuqxw8">
                <h3 className="font-bold text-brand-charcoal text-xl mb-4 flex items-center gap-2" data-id="element-1821" data-mp="2ai9ypcej3o5v">
                  <Map size={24} className="text-brand-maroon" data-id="element-1822" data-mp="1wihb3pyato24" />
                  USPS Route & Development Mapping
                </h3>
                <p className="text-brand-muted mb-4" data-id="element-1823" data-mp="20kcf527m6fjl">
                  With 20+ years of experience in commercial mapping and
                  community planning, we provide value-engineered tenant layouts
                  to reduce cost, increase efficiency, and remain in accordance
                  with USPS regulations.
                </p>
                <ul className="space-y-2 text-brand-muted text-sm" data-id="element-1824" data-mp="2jif3desc88gc">
                  <li className="flex items-start gap-2" data-id="element-1825" data-mp="2jglvjw5zni6r">
                    <span className="w-1.5 h-1.5 rounded-full bg-brand-maroon mt-1.5 shrink-0" data-id="element-1826" data-mp="377rg2omviyne"></span>
                    <span data-id="element-1827" data-mp="3bzrj4py8q7o7">Estimates based on researched and built layouts</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-1828" data-mp="10ipe5r4d7r3w">
                    <span className="w-1.5 h-1.5 rounded-full bg-brand-maroon mt-1.5 shrink-0" data-id="element-1829" data-mp="vkntj1rajjqb"></span>
                    <span data-id="element-1830" data-mp="1a9k9dkzla11h">
                      Access to site plans and recommendations once awarded
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-1831" data-mp="15azbhs7t7tg7">
                    <span className="w-1.5 h-1.5 rounded-full bg-brand-maroon mt-1.5 shrink-0" data-id="element-1832" data-mp="hkd29xm2k34m"></span>
                    <span data-id="element-1833" data-mp="cmbitbkqe1sm">
                      Guidance on USPS approval and address sequencing
                    </span>
                  </li>
                </ul>
              </div>

              <div className="bg-brand-background p-8 rounded-xl border border-brand-border" data-id="element-1834" data-mp="mk9882ebu4mt">
                <h3 className="font-bold text-brand-charcoal text-xl mb-4 flex items-center gap-2" data-id="element-1835" data-mp="22y7tvecikmdz">
                  <Wrench size={24} className="text-brand-maroon" data-id="element-1836" data-mp="1xzeo683gxzod" />
                  CBU Installation Services
                </h3>
                <p className="text-brand-muted mb-4" data-id="element-1837" data-mp="1jmo3oqwhg8nk">
                  Managing a Cluster Box Unit (CBU) replacement or new
                  development can be daunting. Let us take the reins of the
                  installation while adhering to USPS postal codes.
                </p>
                <ul className="space-y-2 text-brand-muted text-sm" data-id="element-1838" data-mp="14zl8iqvmuc3e">
                  <li className="flex items-start gap-2" data-id="element-1839" data-mp="zzqg2iw7leg8">
                    <span className="w-1.5 h-1.5 rounded-full bg-brand-maroon mt-1.5 shrink-0" data-id="element-1840" data-mp="1019yog5c81l6"></span>
                    <span data-id="element-1841" data-mp="vwk3yumf0t1u">Address Sequencing Approved by USPS</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-1842" data-mp="qztnw7am1xgf">
                    <span className="w-1.5 h-1.5 rounded-full bg-brand-maroon mt-1.5 shrink-0" data-id="element-1843" data-mp="m079vvmykd6k"></span>
                    <span data-id="element-1844" data-mp="2ldl5bsz6llmf">
                      Communications with local postal service to manage
                      schedule
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-1845" data-mp="2nxhhc7j6wuun">
                    <span className="w-1.5 h-1.5 rounded-full bg-brand-maroon mt-1.5 shrink-0" data-id="element-1846" data-mp="2nwyapmyzpsvx"></span>
                    <span data-id="element-1847" data-mp="2suzu690bvu7x">
                      Individual key testing and house address labeling
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-1848" data-mp="32m48d6i6jb1p">
                    <span className="w-1.5 h-1.5 rounded-full bg-brand-maroon mt-1.5 shrink-0" data-id="element-1849" data-mp="32lm1lfxw5efj"></span>
                    <span data-id="element-1850" data-mp="250g98ducaemh">Removal & Disposal of Old System</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Commercial FAQs */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1851" data-mp="2ew05x2gq9hca">
              <div className="border border-brand-border rounded-lg p-5" data-id="element-1852" data-mp="2jwfhbohg8erm">
                <h4 className="font-bold text-brand-charcoal mb-2 text-sm" data-id="element-1853" data-mp="3qbyk1kqritkd">
                  Need to replace a CBU part?
                </h4>
                <p className="text-sm text-brand-muted" data-id="element-1854" data-mp="3va0345o6usvu">
                  Email a photo of the damaged unit/part. We'll diagnose the
                  model, year, and part ID, then provide a quote based on
                  manufacturer lead time.
                </p>
              </div>
              <div className="border border-brand-border rounded-lg p-5" data-id="element-1855" data-mp="249rnn753qyav">
                <h4 className="font-bold text-brand-charcoal mb-2 text-sm" data-id="element-1856" data-mp="208626xei5bp2">
                  Large project starting point?
                </h4>
                <p className="text-sm text-brand-muted" data-id="element-1857" data-mp="1cj3k5ofyhgu1">
                  We'll ask guided questions to jumpstart the process and
                  provide options based on your specific development needs.
                </p>
              </div>
              <div className="border border-brand-border rounded-lg p-5" data-id="element-1858" data-mp="1gjxbkrslxdro">
                <h4 className="font-bold text-brand-charcoal mb-2 text-sm" data-id="element-1859" data-mp="1ghsvzclciqbk">
                  Carrier denying delivery?
                </h4>
                <p className="text-sm text-brand-muted" data-id="element-1860" data-mp="ot9crmeeokh6">
                  Contact your local post office to determine the cause (damaged
                  locks, noncompliance). We can then quote the necessary code
                  updates.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* USPS Compliance & Mailbox Types */}
        <section className="py-16 bg-brand-background border-b border-brand-border" data-id="element-1861" data-mp="9ppr36d4gt4c">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1862" data-mp="9nd9wvf6umsc">
            <h2 className="text-2xl font-serif font-bold text-brand-charcoal mb-8 text-center" data-id="element-1863" data-mp="xgc0b0yv4jfx">
              Commercial Mailbox Compliance
            </h2>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-1864" data-mp="nh4k860quap4">
              {/* 4C Mailboxes */}
              <div className="bg-white p-8 rounded-xl border border-brand-border shadow-sm" data-id="element-1865" data-mp="sg7in7m7xio4">
                <h3 className="font-bold text-brand-charcoal text-xl mb-3" data-id="element-1866" data-mp="387btrb8go2nm">
                  4C USPS Approved Mailboxes
                </h3>
                <p className="text-brand-muted mb-4" data-id="element-1867" data-mp="3d7hlssin7r68">
                  Centralized, multi-unit mailboxes designed for commercial mail
                  delivery. Commonly found in apartments, commercial buildings,
                  and new residential developments.
                </p>
                <ul className="space-y-2 text-brand-muted text-sm" data-id="element-1868" data-mp="3jmyngqqi98uv">
                  <li className="flex items-start gap-2" data-id="element-1869" data-mp="3eooridwyi487">
                    <CheckCircle2 size={16} className="text-brand-green shrink-0 mt-0.5" data-id="element-1870" data-mp="3eq88k6qfsjb1" />
                    <span data-id="element-1871" data-mp="b7ewjydb42iz">
                      Compliant with the newest USPS STD-4C Regulations
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-1872" data-mp="670m69o8gghs">
                    <CheckCircle2 size={16} className="text-brand-green shrink-0 mt-0.5" data-id="element-1873" data-mp="1ajythouy65r" />
                    <span data-id="element-1874" data-mp="2qwzs6dlpwfhr">
                      Numerous pre-configured modules and colors available
                    </span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-1875" data-mp="11iqhiojlkrbf">
                    <CheckCircle2 size={16} className="text-brand-green shrink-0 mt-0.5" data-id="element-1876" data-mp="11g4aqr4j6fu9" />
                    <span data-id="element-1877" data-mp="1bfczn5kjh49r">Includes locks with 3 keys per tenant slot</span>
                  </li>
                </ul>
              </div>

              {/* 4B+ Warning */}
              <div className="bg-brand-maroon/5 p-8 rounded-xl border border-brand-maroon/20 shadow-sm relative overflow-hidden" data-id="element-1878" data-mp="1l6hdg1yhaj30">
                <div className="absolute top-0 right-0 p-4 opacity-10" data-id="element-1879" data-mp="1p68dyxdt4dkq">
                  <AlertTriangle size={100} className="text-brand-maroon" data-id="element-1880" data-mp="1u6csihv5my8b" />
                </div>
                <h3 className="font-bold text-brand-maroon text-xl mb-3 flex items-center gap-2 relative z-10" data-id="element-1881" data-mp="1z5z6itit4ii6">
                  <AlertTriangle size={24} data-id="element-1882" data-mp="3vz0ygyz6nzrs" />
                  4B+ Horizontal & Vertical Mailboxes
                </h3>
                <p className="text-brand-charcoal/80 mb-4 relative z-10 font-medium" data-id="element-1883" data-mp="4s7ytzk1g8pd">
                  Phased out for new installations as of October 2006.
                </p>
                <div className="space-y-3 text-sm text-brand-charcoal/70 relative z-10" data-id="element-1884" data-mp="3ovui0frl3tm2">
                  <p data-id="element-1885" data-mp="6pg4ghx89lo7">
                    USPS requires properties to be updated to current standards
                    (CBU or 4C) when any renovation occurs. Confirm USPS
                    approval prior to purchase as these are non-refundable if
                    denied.
                  </p>
                  <p className="font-semibold text-brand-maroon" data-id="element-1886" data-mp="bp2gwp58exvy">
                    *MidAtlantic Mailbox, Inc. will not install 4B+ Horizontal
                    and Vertical Mailboxes without direct Postmaster Approval.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Street Signs */}
        <section className="py-16 lg:py-24 bg-white border-b border-brand-border" data-id="element-1887" data-mp="ueqylgk2ohtd">
          <div className="max-w-7xl mx-auto px-4" data-id="element-1888" data-mp="uco0e98rnidk">
            <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-1889" data-mp="1e1lrp445mrkh">
              <div className="lg:w-1/3 flex justify-center" data-id="element-1890" data-mp="1i1vzmmbibs1z">
                <div className="w-32 h-32 rounded-full bg-brand-goldWash flex items-center justify-center border-4 border-white shadow-lg" data-id="element-1891" data-mp="1i01lbquqqy6v">
                  <Signpost size={64} className="text-brand-charcoal" data-id="element-1892" data-mp="190y0oifxeaq9" />
                </div>
              </div>
              <div className="lg:w-2/3" data-id="element-1893" data-mp="ucb99id0xsio">
                <h2 className="text-3xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-1894" data-mp="uagpi7dho6g6">
                  Street Signs & Traffic Signs
                </h2>
                <p className="text-lg text-brand-muted mb-6" data-id="element-1895" data-mp="lcoaz5fld2tu">
                  Decorative and Municipality Sign Systems. We specialize in
                  street-planning, full-system replacements, decorative street
                  sign packages, and replacement parts.
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-1896" data-mp="gd1v0o8dp8hc">
                  <div data-id="element-1897" data-mp="vute2q9u8p5f">
                    <h4 className="font-bold text-brand-charcoal mb-2" data-id="element-1898" data-mp="vv376mq6jcfc">
                      FREE Estimating & Diagnostics
                    </h4>
                    <p className="text-sm text-brand-muted" data-id="element-1899" data-mp="rr3tebwaarpo">
                      Trouble finding an exact model? We help identify the
                      model, manufacturer, and size of parts needed, or provide
                      the best visual match if discontinued.
                    </p>
                  </div>
                  <div data-id="element-1900" data-mp="858xge15q3zb">
                    <h4 className="font-bold text-brand-charcoal mb-2" data-id="element-1901" data-mp="84z3kfczrcoc">
                      Installation Services
                    </h4>
                    <p className="text-sm text-brand-muted" data-id="element-1902" data-mp="43vo3tyuvinn">
                      Over 10 years of experience installing standard and
                      decorative systems per manufacturer guidelines, DOT
                      regulations, and municipality preferences. Includes
                      removal of old systems.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Service Area & CTA */}
        <section className="py-16 lg:py-24 bg-brand-charcoal text-white text-center" data-id="element-1903" data-mp="3g52ioc62knhh">
          <div className="max-w-4xl mx-auto px-4" data-id="element-1904" data-mp="3l6jeht9p5jr7">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-maroon mb-6" data-id="element-1905" data-mp="3q4teqiaa3ajo">
              <MapPin size={32} className="text-white" data-id="element-1906" data-mp="2si445k1ifpm7" />
            </div>
            <h2 className="text-3xl font-serif font-bold mb-6" data-id="element-1907" data-mp="2xgff5y3jk660">
              Our Installation Service Area
            </h2>
            <p className="text-lg text-gray-300 mb-8" data-id="element-1908" data-mp="32f8pjhnj7h1y">
              We proudly provide professional installation services to parts of:
            </p>
            <div className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-1909" data-mp="378bknu7yiyk9">
              {['Maryland', 'Pennsylvania', 'Washington D.C.', 'Virginia', 'West Virginia'].map(state => <span key={state} className="bg-white/10 border border-white/20 px-4 py-2 rounded-full text-sm font-medium" data-id="element-1910" data-mp="asmq5gghuj4r">
                  {state}
                </span>)}
            </div>

            <div className="bg-white/5 border border-white/10 rounded-2xl p-8 max-w-2xl mx-auto backdrop-blur-sm" data-id="element-1911" data-mp="osxheklptzqg">
              <h3 className="text-2xl font-bold mb-4" data-id="element-1912" data-mp="3o8u82uhx86av">Get Started Today!</h3>
              <p className="text-gray-300 mb-8" data-id="element-1913" data-mp="3t6cgmjs10jic">
                MidAtlantic Mailbox is here to help with all your mailbox and
                street-sign needs. Contact us today for a free consultation.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-1914" data-mp="5ul7uxqw6nuc">
                <a href="tel:301-620-7585" className="bg-brand-gold hover:bg-brand-gold/90 text-brand-charcoal px-8 py-4 rounded-md font-bold transition-colors shadow-sm w-full sm:w-auto flex items-center justify-center gap-2 text-lg" data-id="element-1915" data-mp="35g8ekguhkrtg">
                  <PhoneCall size={20} data-id="element-1916" data-mp="2x011ko2owntm" />
                  Call 301-620-7585
                </a>
                <a href="/ContactUs.html" className="bg-transparent border-2 border-white hover:bg-white hover:text-brand-charcoal text-white px-8 py-4 rounded-md font-bold transition-colors shadow-sm w-full sm:w-auto text-lg" data-id="element-1917" data-mp="2sxw9vuvsy19m">
                  Contact Us Online
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-1918" data-mp="29bhsi6btg70h" />
      <MobileStickyBar data-id="element-1919" data-mp="29b83om2ic5wd" />
    </div>;
}